function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var e = function e(_e) {
    return "object" == _typeof(_e) && null != _e && 1 === _e.nodeType;
  },
  t = function t(e, _t) {
    return (!_t || "hidden" !== e) && "visible" !== e && "clip" !== e;
  },
  n = function n(e, _n) {
    if (e.clientHeight < e.scrollHeight || e.clientWidth < e.scrollWidth) {
      var _l = getComputedStyle(e, null);
      return t(_l.overflowY, _n) || t(_l.overflowX, _n) || function (e) {
        var t = function (e) {
          if (!e.ownerDocument || !e.ownerDocument.defaultView) return null;
          try {
            return e.ownerDocument.defaultView.frameElement;
          } catch (e) {
            return null;
          }
        }(e);
        return !!t && (t.clientHeight < e.scrollHeight || t.clientWidth < e.scrollWidth);
      }(e);
    }
    return !1;
  },
  l = function l(e, t, n, _l2, i, o, r, d) {
    return o < e && r > t || o > e && r < t ? 0 : o <= e && d <= n || r >= t && d >= n ? o - e - _l2 : r > t && d < n || o < e && d > n ? r - t + i : 0;
  },
  i = function i(e) {
    var t = e.parentElement;
    return null == t ? e.getRootNode().host || null : t;
  };
var o = function o(t, _o2) {
  var r, d, h, f, u, s;
  if ("undefined" == typeof document) return [];
  var a = _o2.scrollMode,
    c = _o2.block,
    g = _o2.inline,
    m = _o2.boundary,
    p = _o2.skipOverflowHiddenElements,
    w = "function" == typeof m ? m : function (e) {
      return e !== m;
    };
  if (!e(t)) throw new TypeError("Invalid target");
  var W = document.scrollingElement || document.documentElement,
    H = [],
    b = t;
  for (; e(b) && w(b);) {
    if (b = i(b), b === W) {
      H.push(b);
      break;
    }
    null != b && b === document.body && n(b) && !n(document.documentElement) || null != b && n(b, p) && H.push(b);
  }
  var v = null != (d = null == (r = window.visualViewport) ? void 0 : r.width) ? d : innerWidth,
    y = null != (f = null == (h = window.visualViewport) ? void 0 : h.height) ? f : innerHeight,
    E = null != (u = window.scrollX) ? u : pageXOffset,
    M = null != (s = window.scrollY) ? s : pageYOffset,
    _t$getBoundingClientR = t.getBoundingClientRect(),
    x = _t$getBoundingClientR.height,
    I = _t$getBoundingClientR.width,
    C = _t$getBoundingClientR.top,
    R = _t$getBoundingClientR.right,
    T = _t$getBoundingClientR.bottom,
    V = _t$getBoundingClientR.left,
    k = "start" === c || "nearest" === c ? C : "end" === c ? T : C + x / 2,
    B = "center" === g ? V + I / 2 : "end" === g ? R : V,
    D = [];
  for (var _e2 = 0; _e2 < H.length; _e2++) {
    var _t2 = H[_e2],
      _t$getBoundingClientR2 = _t2.getBoundingClientRect(),
      _n2 = _t$getBoundingClientR2.height,
      _i = _t$getBoundingClientR2.width,
      _o = _t$getBoundingClientR2.top,
      _r = _t$getBoundingClientR2.right,
      _d = _t$getBoundingClientR2.bottom,
      _h = _t$getBoundingClientR2.left;
    if ("if-needed" === a && C >= 0 && V >= 0 && T <= y && R <= v && C >= _o && T <= _d && V >= _h && R <= _r) return D;
    var _f = getComputedStyle(_t2),
      _u = parseInt(_f.borderLeftWidth, 10),
      _s = parseInt(_f.borderTopWidth, 10),
      _m = parseInt(_f.borderRightWidth, 10),
      _p = parseInt(_f.borderBottomWidth, 10),
      _w = 0,
      _b = 0,
      O = "offsetWidth" in _t2 ? _t2.offsetWidth - _t2.clientWidth - _u - _m : 0,
      X = "offsetHeight" in _t2 ? _t2.offsetHeight - _t2.clientHeight - _s - _p : 0,
      Y = "offsetWidth" in _t2 ? 0 === _t2.offsetWidth ? 0 : _i / _t2.offsetWidth : 0,
      L = "offsetHeight" in _t2 ? 0 === _t2.offsetHeight ? 0 : _n2 / _t2.offsetHeight : 0;
    if (W === _t2) _w = "start" === c ? k : "end" === c ? k - y : "nearest" === c ? l(M, M + y, y, _s, _p, M + k, M + k + x, x) : k - y / 2, _b = "start" === g ? B : "center" === g ? B - v / 2 : "end" === g ? B - v : l(E, E + v, v, _u, _m, E + B, E + B + I, I), _w = Math.max(0, _w + M), _b = Math.max(0, _b + E);else {
      _w = "start" === c ? k - _o - _s : "end" === c ? k - _d + _p + X : "nearest" === c ? l(_o, _d, _n2, _s, _p + X, k, k + x, x) : k - (_o + _n2 / 2) + X / 2, _b = "start" === g ? B - _h - _u : "center" === g ? B - (_h + _i / 2) + O / 2 : "end" === g ? B - _r + _m + O : l(_h, _r, _i, _u, _m + O, B, B + I, I);
      var _e3 = _t2.scrollLeft,
        _f2 = _t2.scrollTop;
      _w = Math.max(0, Math.min(_f2 + _w / L, _t2.scrollHeight - _n2 / L + X)), _b = Math.max(0, Math.min(_e3 + _b / Y, _t2.scrollWidth - _i / Y + O)), k += _f2 - _w, B += _e3 - _b;
    }
    D.push({
      el: _t2,
      top: _w,
      left: _b
    });
  }
  return D;
};
export { o as default }; //# sourceMappingURL=index.js.map